import React from 'react'
import { Col, Row } from 'rsuite'

export default function HTMLWidget({ data, ...props }) {
  return (
    <>
      {data && (
        <div {...props}>
          {/* <Row {...props}> */}
          {/* <Col> */}
          {/* <i> */}
          <div dangerouslySetInnerHTML={{ __html: data }} />
          {/* </i> */}
          {/* </Col> */}
          {/* </Row> */}
        </div>
      )}
    </>
  )
}
